import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';




const FieldTripClass92026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/5.webp`;
const p6 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/6.webp`;
const p7 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip9/7.webp`;

const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}
,{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
}



  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FIELD TRIP CLASS 9
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 9	 Date: 09 September 2026 

        </Typography>
         <Typography
                  variant={'h6'}
                  color={'primary'}
                  align={'center'}
                  fontWeight={'normal'}
                ><br/>
Venue: Mysore Palace, Mysore Rail Museum & Payana Vintage Car Museum
        <br/>
                </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
A one-day field trip for the students of Class 9 was organised on 18 September 2026 to Mysore. The trip was organized to provide experiential learning beyond the classroom by connecting students 
with cultural heritage, technological evolution and history of transport.
 <br></br>
The first stop was the majestic Mysore Palace. Students marvelled at the Indo-Saracenic architecture, the ornate Durbar Hall, paintings and royal artefacts of the Wadiyar dynasty. The visit helped them to appreciate our cultural heritage and architecture. Next, the students visited the Mysore Rail Musuem, India’s second oldest rail museum near Mysore Railway Station. Students explored the outdoor exhibits of steam, diesel and electric locomotives. The main attraction was the royal Maharani Saloon Coach used by the queen of Mysore. The final destination was the Payana Vintage Car Museum at Srirangapatna, located on the Bangalore-Mysore highway. Students were fascinated to see vintage cars displayed in chronological order -from a 1925 Fiat 501, 1929 Studebaker, WWII Jeeps to the Maharaja of Mysore’s 1949 Daimler and the iconic Ambassador. This
 gave students an insight into the evolution of automobiles and the art of preservation. 
     <br></br>
The field trip concluded on a happy note with students returning with memorable experiences, photographs and renewed sense of curiosity.
 Overall, the visit was an enriching and enjoyable learning experience.     
  <br></br>
       
        
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
         From Thrones to Tracks-Tracing History on Wheels…. Past Preserved, Present Inspired!

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTripClass92026;